import { makeStyles } from "@mui/styles";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

export const useStyles = makeStyles((theme) => ({
  root: {},
  filterBtnGroup: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    gap: 6,
    padding: "6px",
  },
  tooltip: {
    backgroundColor: "black !important",
  },
  activeFilterBtn: {
    background: "#0F56CA !important",
    border: "1px solid #0F56CA !important",
    color: "white !important",
  },
  table: {
    borderTop: "1px solid #CCCCCC",
  },
  badge: {
    borderRadius: "22px",
    width: "32px",
    height: "22px",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "16px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  success: {
    backgroundColor: "#E9FBEF",
    border: "1px solid #87E8AD",
    color: "#414651",
  },
  warning: {
    border: "1px solid #daa520",
    background: "#fff4d9",
    color: "#daa520",
  },
  danger: {
    color: "#B42419",
    border: "1px solid #FDA19B",
    background: "#FEF3F2",
  },
}));

export const ValueBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "color",
})<{ color?: string }>(({ color }) => ({
  display: "flex",
  alignItems: "flex-start",
  wordBreak: "break-all",
  fontWeight: 500,
  lineHeight: "16px",
  textAlign: "right",
  color: color || "inherit",
}));
